module.exports = __webpack_public_path__ + "static/media/home-service-slider-2.f3ce78f6.jpg";